import { AM_BANK_ACCOUNT_STATUS } from 'src/app';

export interface IBankAccountResponse {
  id: string;
  holder_full_name: string;
  bank_account_number: string;
  bank_code: string;
  verification_status: string;
  type: string;
  sob_account_id: number;
  sob_bank_id: number;
}

export interface IBankAccountRequest {
  legacy_contract_id: string;
  bank_code: string;
  bank_account_type: string;
  bank_account_number: string;
}

export interface IBankAccount {
  id: string;
  holderFullName: string;
  bankAccountNumber: string;
  bankCode: string;
  verificationStatus: string;
  type: string;
  sobAccountId: number;
  sobBankId: number;
  bankName?: string;
}

export interface IAllBankAccountInformationResponse {
  accountId: string;
  bankAccountId: number;
  bankAccountNumber: string;
  bankId: number;
  bankName: string;
  scheduleDepositsEnabled: boolean;
  termsAndConditions: boolean;
  subAccountId: number;
  ssiId: number;
  isPropietaryAccount: boolean;
  isAuthorizedByTransactDesk: boolean;
  isAuthorizedByTreasury: boolean;
  automaticVerification: boolean;
  automaticDeposits: boolean;
  checkingAccountStatus: number;
  checkingAccountVerification: boolean;
}

export class BankAccountViewModel implements IBankAccount {
  public isValidAccount: boolean;

  static fromJSON(json: IBankAccountResponse): BankAccountViewModel {
    return new BankAccountViewModel(
      json.id,
      json.holder_full_name,
      json.bank_account_number,
      json.bank_code,
      json.verification_status,
      json.type,
      json.sob_account_id,
      json.sob_bank_id,
    );
  }

  static toJSON(json: any): IBankAccountRequest {
    return Object.assign(
      {},
      {
        legacy_contract_id: json.legacyContractId,
        bank_code: json.bankCode,
        bank_account_type: json.bankAccountType,
        bank_account_number: json.bankAccountNumber,
      },
    );
  }

  static fromOldJSON(
    json: IAllBankAccountInformationResponse,
  ): BankAccountViewModel {
    const sobActiveCheckingAccountStatus = 1;
    const verificationStatus =
      json.checkingAccountStatus === sobActiveCheckingAccountStatus &&
      json.checkingAccountVerification
        ? AM_BANK_ACCOUNT_STATUS.VERIFIED
        : AM_BANK_ACCOUNT_STATUS.PENDING;

    return new BankAccountViewModel(
      '',
      '',
      json.bankAccountNumber,
      '',
      verificationStatus,
      'clabe',
      json.bankAccountId,
      json.bankId,
      json.bankName,
    );
  }

  constructor(
    public id: string,
    public holderFullName: string,
    public bankAccountNumber: string,
    public bankCode: string,
    public verificationStatus: string,
    public type: string,
    public sobAccountId: number,
    public sobBankId: number,
    public bankName?: string,
  ) {
    this.isValidAccount =
      verificationStatus === AM_BANK_ACCOUNT_STATUS.VERIFIED;
  }
}

export interface BankViewModel {
  countryCode: string;
  isAutomaticDepositEnabled: boolean;
  gbmBankReferenceNumber: number;
  shortName: string;
  bankRoutingNumberTypeId: number;
  gbmBankId: number;
  name: string;
  bankRoutingNumberType: string;
  referenceNumber: string;
  scheduleDepositsEnabled: boolean;
  bankId: number;
  id: number;
}
